export const messages = {
    "wre-dashboard.nav-menu.item.shared": "Delinger",
    "wre-dashboard.nav-menu.item.backups": "Sikkerhetskopier",
    "wre-dashboard.nav-menu.item.machines": "Maskiner",
    "wre-dashboard.nav-menu.item.account": "Konto",
    "wre-dashboard.search.input.hint": "Søk",
    "wre-dashboard.search.label.breadcrumb": "Søkeresultater",
    "wre-dashboard.search.message.empty": "Ingen elementer stemmer overens med søket ditt",
    "wre-dashboard.side-bar.selected.title:plural": "{count} elementer er valgt | {count} element er valgt | {count} elementer er valgt",
    "wre-dashboard.side-bar.backup-type.disk": "Disk",
    "wre-dashboard.side-bar.backup-type.file": "Fil",
    "wre-dashboard.side-bar.backup-type.notarized": "Attesterte filer og foldere",
    "wre-dashboard.side-bar.backup-type.exchange": "Applikasjon – Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "Applikasjon – Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "Applikasjon – Systemtilstand",
    "wre-dashboard.side-bar.backup-type.application": "Applikasjon",
    "wre-dashboard.space-indicator.label.left": "{spaceFree} igjen",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} brukt",
    "wre-dashboard.space-indicator.label.unlimited": "Ubegrenset",
    "wre-dashboard.backups-table.column.name": "Navn",
    "wre-dashboard.backups-table.column.size": "Størrelse",
    "wre-dashboard.backups-table.column.version": "Siste sikkerhetskopi",
    "wre-dashboard.backups-table.message.no-backups": "Det finnes foreløpig ingen sikkerhetskopier i Cloud",
    "wre-dashboard.backups-sidebar.label.size": "Størrelse",
    "wre-dashboard.backups-sidebar.label.type": "Type",
    "wre-dashboard.backups-sidebar.label.version": "Siste versjon",
    "wre-dashboard.backups-sidebar.label.created": "Opprettet",
    "wre-dashboard.backups-sidebar.label.machine": "Maskin",
    "wre-dashboard.backups-sidebar.label.owner": "Eier",
    "wre-dashboard.content-table.column.name": "Navn",
    "wre-dashboard.content-table.column.versions": "Versjoner",
    "wre-dashboard.content-table.column.volumes": "Volumer",
    "wre-dashboard.content-table.column.path": "Bane",
    "wre-dashboard.content-table.column.size": "Størrelse",
    "wre-dashboard.content-table.column.version": "Siste versjon",
    "wre-dashboard.content-table.action.versions": "Versjoner",
    "wre-dashboard.content-table.action.restore": "Last ned",
    "wre-dashboard.content-table.action.share": "Del kobling",
    "wre-dashboard.content-table.label.size": "Størrelse",
    "wre-dashboard.content-table.label.created": "Opprettet",
    "wre-dashboard.content-table.label.modified": "Endret",
    "wre-dashboard.content-table.message.empty-folder": "Denne mappen er tom",
    "wre-dashboard.password-dialog-box.title.backup": "Kryptert sikkerhetskopi",
    "wre-dashboard.password-dialog-box.title.archive": "Kryptert arkiv",
    "wre-dashboard.password-dialog-box.message.backup": "Spesifiser passordet for å få tilgang til sikkerhetskopien {displayName}",
    "wre-dashboard.password-dialog-box.message.archive": "Spesifiser passordet for å få tilgang til arkivet {displayName}",
    "wre-dashboard.password-dialog-box.hint.password": "Passord",
    "wre-dashboard.password-dialog-box.message.invalid-password": "Passordet er feil",
    "wre-dashboard.form.button.open": "Åpne",
    "wre-dashboard.form.button.close": "Lukk",
    "wre-dashboard.form.button.cancel": "Avbryt",
    "wre-dashboard.form.button.delete": "Slett",
    "wre-dashboard.shared-content-table.column.name": "Navn",
    "wre-dashboard.shared-content-table.column.location": "Plassering",
    "wre-dashboard.shared-content-table.column.source": "Kilde",
    "wre-dashboard.shared-content-table.column.days": "Dager",
    "wre-dashboard.shared-content-table.column.downloads": "Nedlastinger",
    "wre-dashboard.shared-content-table.column.shared": "Delt",
    "wre-dashboard.shared-content-table.label.shared": "Delt",
    "wre-dashboard.shared-content-table.label.backup": "Kilde",
    "wre-dashboard.shared-content-table.action.share": "Del kobling",
    "wre-dashboard.shared-content-table.action.settings": "Koblingsinnstillinger",
    "wre-dashboard.shared-content-table.action.delete": "Slett kobling",
    "wre-dashboard.shared-content-table.action.delete-selected": "Slett koblinger",
    "wre-dashboard.account-page.message.used-space": "{brandName}: {spaceFree} ledig av {totalSpace}",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}: Ubegrenset plass",
    "wre-dashboard.account-page.button.sign-out": "Logg av",
    "wre-dashboard.account-page.button.manage-subscription": "Administrer lisens",
    "wre-dashboard.account-page.message.subscription.active": "Lisensen din for {brandName} plass utløper den",
    "wre-dashboard.account-page.message.subscription.trial": "{brandName} Prøveversjon er aktiv inntil",
    "wre-dashboard.account-page.message.subscription.expired": "Lisensen din for {brandName} plass utløpt den",
    "wre-dashboard.account-page.message.worm-status.storage-full": "{brandName}-lagringen din er full. Du kan ikke sikkerhetskopiere eller arkivere data i Cloud.",
    "wre-dashboard.account-page.message.worm-status.less-than": "Mindre enn {percent} prosent ledig. Du vil snart ikke kunne bruke {brandName}.",
    "wre-dashboard.versions-dialog-box.title": "Versjoner av {fileName}",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "Kopier kobling",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "Koblingsinnstillinger",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "Alle med denne koblingen kan se den siste versjonen av dataene",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "Delt {creationDate}",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "Kobling er kopiert",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "Feil ved kopiering av kobling",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "Slett kobling",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "Denne koblingen slutter å fungere for alle som har den",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "Slett koblinger",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "Disse koblingene slutter å fungere for alle som har dem",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "Koblingsinnstillinger",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "Slett kobling",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "Ferdig",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "Passord",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "Tilbakestill passord",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "Passordbeskyttelse",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "Beskytt denne koblingen ved å bruke et passord",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "Utløper",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "Nedlastingsgrense",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "Deaktiver denne koblingen om {splitMarker} dager | Deaktiver denne koblingen om {splitMarker} dag | Deaktiver denne koblingen om {splitMarker} dager",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "Deaktiver denne koblingen etter {splitMarker} nedlastinger | Deaktiver denne koblingen etter {splitMarker} nedlasting | Deaktiver denne koblingen etter {splitMarker} nedlastinger",
    "wre-dashboard.sub-accounts-dialog-box.title": "Kontoer",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "Søk",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "Ingen elementer stemmer overens med søket ditt",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "Navn",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "Bruk",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "Siste sikkerhetskopi",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "Utløper",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} fri fra {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "Volumabonnement",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "Utløpt",
    "wre-dashboard.machines-table.column.name": "Navn",
    "wre-dashboard.machines-table.column.size": "Størrelse",
    "wre-dashboard.machines-table.message.no-machines": "Det finnes foreløpig ingen maskiner i skyen"
};
